define(['jquery', 'erv_framework', 'forms'], function ($, Framework, Forms) {

	var ERVTranslate = function () {
		var self = this;
		self.framework = new Framework();
		self.forms = new Forms();
		self.cookieName = window.ERV.ConfigurationSettings.CookieStrings.GTranslate;
		self.$body = $('body');
	};

	ERVTranslate.prototype.initNoTranslate = function () {
		var self = this,
			$html = $('html'),
			defaultCurrency = $html.data('currency');

		if (typeof (defaultCurrency) !== 'undefined' && typeof (self.framework.cookies.get(self.cookieName)) !== 'undefined') {
			var pattern = new RegExp('\\b(' + defaultCurrency + ')', 'gi'),
				replaceWith = '<span class="notranslate">$1</span>';

			$('body .price, body [data-js="currency"]').each(function () {
				var $price = $(this);
				$price.html($price.html().replace(pattern, replaceWith));
			});
		}
	};
	
	ERVTranslate.prototype.init = function () {
		window.ERV = window.ERV || {};
		window.ERV.translation = window.ERV.translation || {};
        window.ERV.translation = googleTranslateElementInit;
    }
	
	return ERVTranslate;
});

/* GTranslate start */
eval(function (p, a, c, k, e, r) { e = function (c) { return (c < a ? '' : e(parseInt(c / a))) + ((c = c % a) > 35 ? String.fromCharCode(c + 29) : c.toString(36)) }; if (!''.replace(/^/, String)) { while (c--) r[e(c)] = k[c] || e(c); k = [function (e) { return r[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]); return p }('6 7(a,b){n{4(2.9){3 c=2.9("o");c.p(b,f,f);a.q(c)}g{3 c=2.r();a.s(\'t\'+b,c)}}u(e){}}6 h(a){4(a.8)a=a.8;4(a==\'\')v;3 b=a.w(\'|\')[1];3 c;3 d=2.x(\'y\');z(3 i=0;i<d.5;i++)4(d[i].A==\'B-C-D\')c=d[i];4(2.j(\'k\')==E||2.j(\'k\').l.5==0||c.5==0||c.l.5==0){F(6(){h(a)},G)}g{c.8=b;7(c,\'m\');7(c,\'m\')}}', 43, 43, '||document|var|if|length|function|GTranslateFireEvent|value|createEvent||||||true|else|doGTranslate||getElementById|google_translate_gtranslate|innerHTML|change|try|HTMLEvents|initEvent|dispatchEvent|createEventObject|fireEvent|on|catch|return|split|getElementsByTagName|select|for|className|goog|te|combo|null|setTimeout|500'.split('|'), 0, {}))

function googleTranslateElementInit() {
    var googleTranslateSelect = $('#google_translate_element');

    new google.translate.TranslateElement({
            pageLanguage: $('html').attr('lang'),
            includedLanguages: "af,sq,ar,hy,az,eu,be,bg,ca,zh,zh,hr,cs,da,nl,en,et,tl,fi,fr,gl,ka,de,el,ht,iw,hi,hu,is,id,ga,it,ja,ko,lv,lt,mk,ms,mt,no,fa,pl,pt,ro,ru,sr,sk,sl,es,sw,sv,th,tr,uk,ur,vi,cy,yi",
            layout: google.translate.TranslateElement.InlineLayout.VERTICAL
        }
		, !!googleTranslateSelect ? 'google_translate_element' : 'hidden_google_translate_element');
}
/* GTranslate end */